import { setBodyOverflowHiddenIos as u, preventBodyScroll as d, setBodyOverflowHiddenMobile as f, setBodyOverflowHiddenPc as r } from "@smh/utils/dom";
import { parse as h } from "@smh/utils/ua";
let l = 0, e = 0, s = 0, n = null;
const c = [], t = () => h(navigator.userAgent), k = (o = null) => {
  t().isiOS ? (n = u(), o !== null && c.indexOf(o) === -1 && (o.ontouchstart = (i) => {
    e = i.targetTouches[0].clientY, s = i.targetTouches[0].clientX;
  }, o.ontouchmove = (i) => {
    i.targetTouches.length === 1 && d({
      event: i,
      target: o,
      clientX: s,
      clientY: e
    });
  }, c.push(o))) : l <= 0 && (n = t().isAndroid ? f() : r()), l += 1;
}, a = (o = null) => {
  if (l -= 1, !(l > 0)) {
    if (t().isiOS && o !== null) {
      const i = c.indexOf(o);
      i !== -1 && (o.ontouchmove = null, o.ontouchstart = null, c.splice(i, 1));
    }
    if (typeof n == "function") {
      n();
      return;
    }
  }
};
export {
  k as lock,
  a as unlock
};
